import { IsBoolean, IsEnum, IsString } from 'class-validator';

import { AgreementTypeEnum } from '@onArte/shared/database';

export class AgreementUserModel {
  @IsEnum(AgreementTypeEnum)
  public type: AgreementTypeEnum;

  @IsString()
  public version: string;
  
  @IsBoolean()
  public selected: boolean;

  constructor(
    type: AgreementTypeEnum,
    version: string,
    selected: boolean,
  ) {
    this.type = type;
    this.version = version;
    this.selected = selected;
  }
}
